/**
 * Capitalizes the first letter in a string.
 */
export function capitalizeFirstLetter(string: string) {
	const stringToUpper = String(string);
	return stringToUpper.charAt(0).toUpperCase() + stringToUpper.slice(1);
}
